import { addWindowEventListener, useWindowEvent } from '@fabric-app/hooks/useWindowEvent';
import { createLogger } from '@fabric-app/utils/logging';

function useFabricEvent(eventname, func, options) {
  useWindowEvent(eventname, func, options);
}
function dispatchFabricEvent(eventname, data, options) {
  if (typeof window === "undefined") {
    return;
  }
  const logger = createLogger("useFabricEvent");
  logger.debug("dispatching event", {
    eventname,
    data
  });
  const origin = options?.origin || window;
  origin.dispatchEvent(new CustomEvent(eventname, {
    detail: data
  }));
}
function addFabricEventListener(eventname, func, options) {
  return addWindowEventListener(eventname, func, options);
}

export { addFabricEventListener, dispatchFabricEvent, useFabricEvent };
//# sourceMappingURL=useFabricEvent.js.map
